import { VendorAuditInfo } from "@/mocks/data/vendorAuditService/vendorAudit";
import { VendorAuditTJUserInfo } from "@/mocks/data/vendorAuditService/vendorAuditTJUser";
import { AuditColorMapInfo } from "@/mocks/data/vendorAuditService/auditColorMap";
import { VendorAuditDetailInfo } from "@/mocks/data/vendorAuditService/vendorAuditDetailForm";
import { VendorAuditDocumentInfo } from "@/mocks/data/vendorAuditService/vendorAuditDocument";
import { vendorAuditListFilterInfo } from "@/mocks/data/vendorAuditService/vendorAuditFilter";
import { VendorAuditQuestionnaireInfo } from "@/mocks/data/vendorAuditService/vendorAuditQuestionnaire";
import api from "./api";
import { IVendorAuditApiResponse, IVendorAuditSavePayload } from "@/context/data.types";

const { vendorServiceAPI, glossaryServiceAPI } = api;

const GET_SITE_AUDIT_LIST_PATH = "/siteAudits";
const GET_VENDOR_AUDIT_ONLOAD_DATA_PATH = "/siteAudits/onLoad";
const GET_VENDOR_AUDIT_DROPDOWN_DATA_PATH = "/glossary/audit-regulatory-bulk";
const GET_VENDOR_AUDIT_DETAILS_PATH = "/siteAudits/";
const SAVE_VENDOR_AUDIT_DATA_PATH = "/siteAudits/";

const vendorAudit = {
    

    // function for mock data of vendor audit list in vendor side
    getVendorAuditData: async (): Promise<any> =>{
        try {
        const resp = await vendorServiceAPI.get(GET_SITE_AUDIT_LIST_PATH)
        return resp ? resp?.data : null;
        } catch (error) {
            console.error("Error fetching vendor audit data:", error);
            throw error;
        }
    },

    // function for mock data of vendor audit list in TJ side
    getVendorAuditTJUserData: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        //const resp = VendorAuditTJUserInfo;
        const resp = await vendorServiceAPI.get(GET_SITE_AUDIT_LIST_PATH)
        return resp ? resp?.data : null;
        } catch (error) {
            console.error("Error fetching vendor audit data:", error);
            throw error;
        }
    },

    //Function to get the color map for vendor audit status
    getVendorAuditStatusColor: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = AuditColorMapInfo;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor audit data:", error);
            throw error;
        }
    },

    //Function to get vendor audit details form dropdown data
    getVendorAuditDropdownData: async (): Promise<any> =>{
            try {
            // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
            const resp = await vendorServiceAPI.get(GET_VENDOR_AUDIT_ONLOAD_DATA_PATH);
            return resp ? resp?.data : null;            
            } catch (error) {
                console.error("Error fetching vendor data:", error);
                throw error;
            }
    },

    getVendorOnLoadAuditDropdownData: async (): Promise<any> =>{
            try {
            const resp = await glossaryServiceAPI.get(GET_VENDOR_AUDIT_DROPDOWN_DATA_PATH);
            return resp ? resp?.data : null;            
            } catch (error) {
                console.error("Error fetching vendor data:", error);
                throw error;
            }
    },

    // function for mock data of vendor audit documents
    getVendorAuditDocument: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = VendorAuditDocumentInfo;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor audit data:", error);
            throw error;
        }
    },

    /** GET /siteAudits — normalize filter payload for formatVendorAuditFilterResponse (incl. `skus` → skuNumber). */
    getVendorAuditFilter: async (): Promise<any> => {
        try {
            const resp = await vendorServiceAPI.get(GET_SITE_AUDIT_LIST_PATH);
            const data = resp?.data;
            if (!data || typeof data !== "object") return null;

            // Flat onload shape (same keys as vendor site / siteAudits filter: siteNames, skus, …)
            if (Array.isArray(data.siteNames)) {
                return {
                    siteName: data.siteNames,
                    skuNumber: Array.isArray(data.skus) ? data.skus : [],
                    auditStatus: data.auditStatuses ?? [],
                    productName: data.productNames ?? [],
                    vendorName: data.vendorNames ?? [],
                    auditPersonResponsible: data.auditPersonResponsibles ?? [],
                };
            }

            const f = data.filters;
            if (f && typeof f === "object" && !Array.isArray(f)) {
                const skuNumber =
                    f.skuNumber ??
                    f.skus ??
                    (Array.isArray(data.skus) ? data.skus : []);
                return { ...f, skuNumber };
            }

            if (Array.isArray(f)) {
                return f;
            }

            return f ?? null;
        } catch (error) {
            console.error("Error fetching vendor audit filter data:", error);
            throw error;
        }
    },

    // function for mock data of vendor audit questionnaire
    getVendorAuditDetails: async (id: string): Promise<any> =>{
        try {
            // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
            const resp = await vendorServiceAPI.get(GET_VENDOR_AUDIT_DETAILS_PATH + id);
            return resp ? resp?.data : null;
        } catch (error) {
            console.error("Error fetching vendor audit questionnaire data:", error);
            throw error;
        }
    },

    // function for mock data of vendor audit questionnaire
    saveVendorAuditData: async (vendorAuditDetailsForm: IVendorAuditSavePayload, id: string): Promise<any> =>{
        try {
            const resp = await vendorServiceAPI.put(SAVE_VENDOR_AUDIT_DATA_PATH + id, vendorAuditDetailsForm);
            return resp ? resp?.data : null;
        } catch (error) {
            console.error("Error saving vendor audit data:", error);
            throw error;
        }
    }
    , // function for mock data of vendor audit questionnaire
    getVendorAuditQuestionnaire: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = VendorAuditQuestionnaireInfo;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor audit questionnaire data:", error);
            throw error;
        }
    }
};
 
export default vendorAudit;